import api from './axiosConfig';

export const getProjectSingle = async (slug) => {
    try {
        const response = await api.get(`project/single/${slug}/`);
        return response.data;
    } catch (error) {
        console.error('Error fetching project single:', error);
        throw error;
    }
};

export const getAllProjectSingles = async () => {
    try {
        const response = await api.get('project/single/');
        return response.data;
    } catch (error) {
        console.error('Error fetching all project singles:', error);
        throw error;
    }
};